module.exports = {
  logo: require('./logo.png'),
};
